export default function Logo() {
  return <h1>🌴 Travel List 🧳</h1>;
}
